import React, { useState, useEffect } from 'react';
import searchfaq from '../../Assets/searchfaq.png'
import plusIcon from '../../Assets/addfaq.png';      // Add your plus icon to Assets
import cancelIcon from '../../Assets/closefaq.png';  // Add your cancel/close icon to Assets
import xpat from '../../Assets/xpaticon.png'
import kolab from '../../Assets/kolab.png'
import integrit from '../../Assets/integrit.png'
import imgteam from '../../Assets/Imageteam.png'
import imgteammble from '../../Assets/ourteammble.png'
import x from '../../Assets/x.png'
import linkedin from '../../Assets/linkedin.png'
import classes from './FAQ.module.css';
import Navigation from '../../Components/Navigation/Navigation'
import Footer from '../../Components/Footer/Footer'
import Getstarted from '../../Components/Get started/Getstarted'
import { useLocation } from 'react-router-dom';



const faqData = [
  {
    question: "What can I do with Scaleworkflow ?",
    answer: "ScaleWorkflow offers a comprehensive suite of services to streamline your non-core operations, including custom software development, digital marketing & branding, business support, cloud solutions, process automation, AI training, technical content writing, data scraping, and consulting. We aim to be your one-stop shop for business excellence."
  },
  {
    question: "What is ScaleWorkflow's core focus ?",
    answer: "Our core focus is to provide innovative, technology-driven solutions for your non-core functions, empowering your business to concentrate on growth and success. Our flagship service is custom software development, showcasing our technical expertise."
  },
  {
    question: "What is your approach to working with clients?",
    answer: "Our service delivery process involves five key steps: Discovery (understanding your needs through workshops and interviews), Proposal (presenting tailored solutions, pricing, and timelines), Execution (dedicated project management and regular updates, incorporating client feedback), Delivery (finalizing and handing over the project, providing training and documentation), and Support (ongoing maintenance, updates, and continuous improvement based on feedback). We are client-centric and focused on understanding and solving your unique challenges."
  },
  {
    question: "How does ScaleWorkflow ensure quality and results?",
    answer: "We leverage a specialized team of professionals with deep knowledge in technology and business solutions. Our approach is results-driven, focusing on delivering measurable outcomes that contribute to your business success. We adhere to industry best practices and maintain open communication throughout the project lifecycle."
  },
   {
    question: "What makes ScaleWorkflow different?",
    answer: "Our deep expertise across a range of non-core functions, our versatility as a single partner for diverse business needs, our commitment to delivering measurable results, and our cost-efficient solutions set us apart. We are professional, innovative, and client-centric, acting as your true business partner for excellence – from initial development to long-term growth."
  },
   {
    question: "How can I get started with ScaleWorkflow?",
    answer: (
      <>
        You can explore our detailed services on our website at{' '}
        <a href="https://www.scaleworkflow.com" target="_blank" rel="noopener noreferrer">
          www.scaleworkflow.com
        </a>{' '}
        or request a free, no-obligation consultation to discuss your specific needs by filling out the contact form on the navigation or by emailing us at{' '}
        <a href="mailto:info@scaleworkflow.com">info@scaleworkflow.com</a>.
        We're ready to help you take your business to the next level.
      </>
    )
  },
   {
    question: "What are your typical project timelines?",
    answer: "Project timelines vary significantly depending on the complexity and scope of the services required. During our initial consultation and the \"Proposal\" phase, we will provide you with a detailed project timeline tailored to your specific needs."
  },
   { question: "What are your pricing models?",
    answer: "Our pricing models are tailored to the specific services and project requirements. We offer various options, including fixed-price projects, hourly rates, and retainer-based agreements. We will discuss pricing transparency during the \"Proposal\" phase."
  },
   { question: "What kind of support do you offer after project completion?",
    answer: "We offer ongoing maintenance and support packages to ensure the continued success of the delivered solutions. The specifics of our support services, including response times and service levels, will be outlined in your service agreement."
  },
   {
    question: "How do you handle data privacy and security?",
    answer: "We take data privacy and security seriously. Please refer to our comprehensive Privacy Policy, available at Privacy Policy page, for detailed information on how we collect, use, and protect your data."
  }

  // Add more FAQs as needed
];


const FAQ = () => {

 const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

}, []);

 const handleToggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const location = useLocation();

useEffect(() => {
    window.scrollTo(0, 0);
}, [location]);

  return (
  <>
  <Navigation style={{paddingRight: '40px', paddingLeft: '40px'}} />
    <div className={classes.aboutus}>
      
      <section className={classes.FAQsection}>
        <div>
       <p className={classes.hwcnwhlptxt}>How Can We Help?</p>
       <div className={classes.searchContainer}>
        <img src={searchfaq} className={classes.searchfaq} alt="Hero" />
         <input type="text" className={classes.searchinput} placeholder='Type your question here' />
       </div>
      
       </div>
      </section>

      <section className={classes.faqAccordion}>
        <p className={classes.faqptg}>Frequently asked questions</p>
              {faqData.map((item, idx) => (
                <div key={idx} className={classes.faqItem}>
                  <div className={classes.faqQuestion}
                  onClick={() => handleToggle(idx)}
                      style={{ cursor: 'pointer' }}
                      >
                      
                    <span>{item.question}</span>
                    <img
                      src={openIndex === idx ? cancelIcon : plusIcon}
                      alt={openIndex === idx ? "Close" : "Open"}
                      className={classes.faqIcon}
                      style={{ cursor: 'pointer', marginLeft: '1rem' }}
                    />
                  </div>
                  {openIndex === idx && (
                    <div className={classes.faqAnswer}>
                      {item.answer}
                    </div>
                  )}
                </div>
              ))}
            
      </section>
      
    </div>
    <Footer />
    </>
  );
};

export default FAQ;
